<template>
  <v-container>
    <section>

      <v-layout column align-center justify-center class="blue--text">
        <img src="../assets/logo.png" alt="Vuetify.js" height="200">
        <h1 class="Blue--text mb-2 display-1 text-xs-center">AutoWash Analytics System</h1>
        <a href="https://www.getmethegeek.com" class="subheading mb-3 text-xs-center">Powered by PhasedLogix</a>
      </v-layout>
    </section>
  </v-container>
</template>

<script>
export default {
  name: 'HelloWorld',
  data() {
    return {
      msg: 'Welcome to Your Vue.js App'
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue